import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IEpDialogComponent, EpButtonStyle } from '@epicor/kinetic';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaProductGridModel } from '../../models/epbt-fa-product-grid-model';
import { SearchPageNames } from 'ep-bt-controls';

@Component({
    selector: 'epbt-fa-product-dialog',
    templateUrl: 'epbt-fa-product-dialog.component.html'
})
export class EpbtFaProductDialogComponent implements OnInit, IEpDialogComponent {
    EpButtonStyle = EpButtonStyle;
    instance: import("@epicor/kinetic").EpDialogInstance;
    @Input() searchString: string;
    @Output() onOk: EventEmitter<any> = new EventEmitter<any>();
    @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();
    @Input() branchId: number;
    @Input() loadDataOnload: boolean;
    bistrackSettings: any;
    webTrackUser: any;
    inputModel: EpbtFaProductGridModel;
    selectedProduct: any;

    pageName: string = SearchPageNames.ProductSearch;
    placeholder: string = "";
    
    constructor(private fieldAgentService: EpbtFieldAgentService) {
    }

    ngOnInit(): void {
        this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
            this.bistrackSettings = bistrackSettings;
            this.fieldAgentService.getWebTrackUser((webTrackRes: any) => {
                this.webTrackUser = webTrackRes;
                if (!this.branchId) this.branchId = webTrackRes.webTrackTradingBranch.branchID;//if not set on input take user branch

                this.inputModel = new EpbtFaProductGridModel(this.bistrackSettings, this.webTrackUser, this.branchId, "ProductDialog", this.loadDataOnload);
            });
        });
    }

    onSelectClick(){
        this.onOk.emit(this.selectedProduct);
    }

    onCancelClick(){
        this.onCancel.emit();
    }

    epOnProductGridCellClick($event){
        this.selectedProduct = $event;
    }

    receiveString($event){
        this.searchString = $event;
    }
}